import { ServiceAgreement, ServiceAgreementFilterSettings, ServiceAgreementInformation } from '@model';
import { Action } from '@ngrx/store';

export enum ServiceAgreementsActionTypes {
    ServiceAgreementsLoad = '[ServiceAgreements] Load data',
    ServiceAgreementsLoadSuccess = '[ServiceAgreements] Load success',
    ServiceAgreementsLoadFail = '[ServiceAgreements] Load fail',
    ServiceAgreementsFilterSaveData = '[ServiceAgreements] Save filter',
    SelectTabIndexServiceAgreements = '[ServiceAgreements] Select Tabindex for products/serviceagreements',
    SelectServiceAgreement = '[ServiceAgreements] Select Service Agreement',
    SelectServiceAgreementById = '[ServiceAgreements] Select Service Agreement By Id'
}

export class ServiceAgreementsLoad implements Action {
  readonly type = ServiceAgreementsActionTypes.ServiceAgreementsLoad;
  constructor() {}
}

export class ServiceAgreementsLoadSuccess implements Action {
  readonly type = ServiceAgreementsActionTypes.ServiceAgreementsLoadSuccess;
  constructor(public payload: ServiceAgreement[]) {}
}

export class ServiceAgreementsLoadFail implements Action {
  readonly type = ServiceAgreementsActionTypes.ServiceAgreementsLoadFail;
  constructor(public payload: any) {}
}

export class SelectTabIndexServiceAgreements implements Action{
  readonly type = ServiceAgreementsActionTypes.SelectTabIndexServiceAgreements;  
  constructor(public payload: number){}
}

// ServiceAgreements filter
export class ServiceAgreementsFilterSave implements Action {
  readonly type = ServiceAgreementsActionTypes.ServiceAgreementsFilterSaveData;
  constructor(public payload: ServiceAgreementFilterSettings) {}
}

export class SelectServiceAgreement implements Action {
  readonly type = ServiceAgreementsActionTypes.SelectServiceAgreement;    
  constructor(public payload: ServiceAgreementInformation) {}
}

export class SelectServiceAgreementById implements Action {
  readonly type = ServiceAgreementsActionTypes.SelectServiceAgreementById;
  constructor(public payload: string) {}
}

export type ServiceAgreementsActions =
  | ServiceAgreementsLoad
  | ServiceAgreementsLoadSuccess  
  | ServiceAgreementsLoadFail
  | ServiceAgreementsFilterSave
  | SelectTabIndexServiceAgreements
  | SelectServiceAgreement
  | SelectServiceAgreementById;